<template>
  <div class="traveler">
    <div class="bg-decoration">
      <div class="cloud cloud-1"></div>
      <div class="cloud cloud-2"></div>
      <div class="wave wave-1"></div>
    </div>

    <div class="content">
      <button class="back-btn" @click="goBack">
        <i class="fa-solid fa-arrow-left"></i>
      </button>

      <div class="construction">
        <div class="icon">
          <i class="fa-solid fa-wrench"></i>
        </div>
        <h1>功能建设中</h1>
        <p>敬请期待</p>
        <div class="loader">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "Traveler",
  setup() {
    const router = useRouter();
    const goBack = () => {
      router.push("/");
    };
    return { goBack };
  },
});
</script>

<style scoped>
.traveler {
  position: relative;
  min-height: 100vh;
  background: linear-gradient(180deg, #e8f4fc 0%, #d4e9f7 30%, #f0f6fa 70%, #fafcfd 100%);
  overflow: hidden;
}

.bg-decoration {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.cloud {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.2) 100%);
}

.cloud-1 {
  top: 10%;
  left: 15%;
  width: 180px;
  height: 70px;
  animation: cloudFloat 12s ease-in-out infinite;
}

.cloud-2 {
  top: 15%;
  right: 20%;
  width: 140px;
  height: 50px;
  animation: cloudFloat 15s ease-in-out infinite reverse;
}

@keyframes cloudFloat {
  0%, 100% { transform: translateY(0) translateX(0); opacity: 0.6; }
  50% { transform: translateY(-8px) translateX(3px); opacity: 0.85; }
}

.wave {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 180px;
  background: linear-gradient(180deg, transparent 0%, rgba(200, 220, 240, 0.3) 100%);
}

.wave::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='%23c9a962' fill-opacity='0.12' d='M0,160L48,144C96,128,192,96,288,90.7C384,85,480,107,576,133.3C672,160,768,192,864,197.3C960,203,1056,181,1152,165.3C1248,149,1344,139,1392,133.3L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'%3E%3C/path%3E%3C/svg%3E") no-repeat bottom;
  background-size: cover;
}

.content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 20px;
}

.back-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(201, 169, 98, 0.3);
  border-radius: 12px;
  color: #4a7eb8;
  cursor: pointer;
  transition: all 0.3s;
}

.back-btn:hover {
  background: #4a7eb8;
  border-color: #4a7eb8;
  color: white;
  transform: translateX(-2px);
}

.construction {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.icon {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(74, 126, 184, 0.12), rgba(74, 126, 184, 0.05));
  border: 1px solid rgba(201, 169, 98, 0.3);
  border-radius: 24px;
  font-size: 2.5rem;
  color: #4a7eb8;
  margin-bottom: 24px;
  animation: float 3s ease-in-out infinite;
  box-shadow: 0 8px 32px rgba(74, 126, 184, 0.1);
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-10px) rotate(5deg); }
}

h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #2c4a6e;
  margin: 0 0 8px;
  letter-spacing: 3px;
}

p {
  font-size: 1rem;
  color: #8ba4c4;
  margin: 0 0 40px;
  letter-spacing: 4px;
}

.loader {
  display: flex;
  gap: 8px;
}

.loader span {
  width: 10px;
  height: 10px;
  background: #4a7eb8;
  border-radius: 50%;
  animation: bounce 1.4s ease-in-out infinite both;
}

.loader span:nth-child(1) { animation-delay: -0.32s; }
.loader span:nth-child(2) { animation-delay: -0.16s; }

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
